import { Box, Typography } from "@mui/material";
import React from "react";
import "./../../common/styles/colors.scss";
import "./../components.scss";
import Chart from "react-apexcharts";

export const PieChart = (props) => {
  const { options } = props;

  const series = options.map((option) => option.series);

  const chartOptions = {
    labels: options.map((option) => option.role),
    colors: options.map((option) => option.color),
    legend: {
      fontSize: "12px",
      fontWeight: 400,
      offsetY: -25,
      offsetX: 0,
      itemMargin: {
        horizontal: 5,
        vertical: 0,
      },
      markers: {
        width: 12,
        height: 12,
      },
    },
    stroke: {
      colors: "transparent",
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: function (value) {
          return value + "%";
        },
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "50%",
          labels: {
            show: false,
          },
        },
      },
    },
  };
  return (
    <Box
      component="div"
      className="adviser-pie-chart-container"
      marginBottom={2}
    >
      <Box marginBottom={2}>
        <Typography textAlign="center" fontSize='14px'>Legal shares of inheritance</Typography>
      </Box>
      <Chart options={chartOptions} series={series} type="donut" width={220} />
    </Box>
  );
};
